module.exports = __webpack_public_path__ + "img/PXL_20230525_095212210.adb4c938.jpg";